import { buildModelManager } from "../builder.js";
const DefaultStripeSubscriptionSelection = {
  __typename: true,
  id: true,
  cancelAtPeriodEnd: true,
  createdAt: true,
  currentPeriodEnd: true,
  plan: true,
  profileId: true,
  status: true,
  stripeCustomerId: true,
  stripePriceId: true,
  stripeProductId: true,
  stripeSubscriptionId: true,
  trialEndsAt: true,
  trialStartedAt: true,
  trialStatus: true,
  updatedAt: true
};
const modelApiIdentifier = "stripeSubscription";
const pluralModelApiIdentifier = "stripeSubscriptions";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeSubscriptionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeSubscriptionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeSubscriptionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeSubscriptionSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createStripeSubscription",
    operationReturnType: "CreateStripeSubscription",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      stripeSubscription: { required: false, type: "CreateStripeSubscriptionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "action",
    operationName: "bulkCreateStripeSubscriptions",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateStripeSubscriptionsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "action",
    operationName: "updateStripeSubscription",
    operationReturnType: "UpdateStripeSubscription",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      stripeSubscription: { required: false, type: "UpdateStripeSubscriptionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateStripeSubscriptions",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateStripeSubscriptionsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "action",
    operationName: "startTrialStripeSubscription",
    operationReturnType: "StartTrialStripeSubscription",
    functionName: "startTrial",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "action",
    operationName: "bulkStartTrialStripeSubscriptions",
    functionName: "bulkStartTrial",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "startTrial",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "action",
    operationName: "upgradeStripeSubscription",
    operationReturnType: "UpgradeStripeSubscription",
    functionName: "upgrade",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      stripeSubscription: { required: false, type: "UpgradeStripeSubscriptionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "action",
    operationName: "bulkUpgradeStripeSubscriptions",
    functionName: "bulkUpgrade",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "upgrade",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpgradeStripeSubscriptionsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "action",
    operationName: "upsertStripeSubscription",
    operationReturnType: "UpsertStripeSubscription",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      stripeSubscription: { required: false, type: "UpsertStripeSubscriptionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateStripeSubscriptionResult": { hasReturnType: false },
      "... on UpdateStripeSubscriptionResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertStripeSubscriptions",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertStripeSubscriptionsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultStripeSubscriptionSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "stripeSubscriptionGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const StripeSubscriptionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultStripeSubscriptionSelection,
  operations
);
export {
  DefaultStripeSubscriptionSelection,
  StripeSubscriptionManager
};
//# sourceMappingURL=StripeSubscription.js.map
